import { Stack } from '@mui/material';
import ConfirmPassword from 'components/form/form-fields/confirm-password/confirm-password.component';
import Email from 'components/form/form-fields/email.component';
import FirstName from 'components/form/form-fields/first-name.component';
import LastName from 'components/form/form-fields/last-name.component';
import Password from 'components/form/form-fields/password/password.component';
import Form from 'components/form/form.component';
import MandatoryFieldsInstruction from 'components/form/mandatory-fields-instruction/mandatory-fields-instruction.component';
import InputPhone from 'components/input-phone/input-phone.component';
import Spinner from 'components/spinner/spinner.component';
import TocAndPrivacy from 'components/toc-and-privacy/toc-and-privacy.component';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useGetUserDetails, useMobileSignup } from '../sms-signup.hooks';
import { InfoAlert, SubmitButton } from '../sms-signup.styles';

const SmsSignupForm = () => {
  const { t } = useTranslation();
  const { data, loading: getUserDetailsLoading, error } = useGetUserDetails();
  const { mobileSignup } = useMobileSignup();

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = methods;

  const onSubmit = formData => {
    mobileSignup(formData);
  };

  if (getUserDetailsLoading) return <Spinner />;

  return (
    <Stack
      data-testid="SmsSignup.Container"
      flex={1}
      justifyContent="center"
      width="100%"
    >
      <InfoAlert
        severity={!!error ? 'error' : 'info'}
        data-testid="SmsSignupForm.Alert"
      >
        {error ?? data?.message}
      </InfoAlert>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <MandatoryFieldsInstruction />
          <FirstName
            register={register}
            errors={errors}
            defaultValue={data?.userAccountDTO?.firstName}
          />
          <LastName
            register={register}
            errors={errors}
            defaultValue={data?.userAccountDTO?.lastName}
          />
          <Email register={register} errors={errors} />
          <Password />
          <ConfirmPassword />
          <InputPhone
            defaultValue={data?.userAccountDTO?.phoneNumber}
            disabled
          />

          <SubmitButton
            type="submit"
            data-testid="SmsSignupForm.CustomButton.Submit"
            fullWidth
            disabled={isSubmitting}
          >
            {t('activationPage.button')}
          </SubmitButton>

          <TocAndPrivacy
            description={t('register.termsAndConditions.activateDescription')}
          />
        </Form>
      </FormProvider>
    </Stack>
  );
};

export default SmsSignupForm;
